import { FC, Fragment, ReactElement } from 'react';
import { Grid2, Typography } from 'team-hero-ui';

import type { IColumn, IRow } from '../../interfaces/FormConfig';
import type { IFormSectionRendererProps } from './FormSectionRenderer.types';
import { FormSubTitleStyled } from '../Form/Form.styled';
import { FormItem } from '../FormItem/FormItem';
import { ItemWrapper } from './FormSectionRenderer.styled';

const DEFAULT_MOBILE_COLUMN_WIDTH = 12;
const DEFAULT_DESKTOP_COLUMN_WIDTH = 6;

export const FormSectionRenderer: FC<IFormSectionRendererProps> = ({
  control,
  section,
}) => {
  const renderRows = (rows: IRow[]) => {
    // check if there are rows with items
    const hasItems = rows.some((row) => row.items.length > 0);

    if (!hasItems) {
      return null;
    }
    return (
      <Grid2 container marginBottom={2}>
        {rows.map((row) => {
          // only render form rows, if fields in there are present
          if (row.items.length > 0)
            return (
              <Fragment key={row.key}>
                {!!row.title && (
                  <FormSubTitleStyled>
                    <Typography.H3>{row.title}</Typography.H3>
                  </FormSubTitleStyled>
                )}
                <Grid2 container spacing={1} size={12}>
                  {row.items.map((item) => {
                    return (
                      <ItemWrapper
                        key={item.propertyName}
                        size={{
                          xs: item.mobileWidth || DEFAULT_MOBILE_COLUMN_WIDTH,
                          md: item.desktopWidth || DEFAULT_DESKTOP_COLUMN_WIDTH,
                        }}
                      >
                        <FormItem control={control} element={item} />
                      </ItemWrapper>
                    );
                  })}
                </Grid2>
              </Fragment>
            );
        })}
      </Grid2>
    );
  };

  const renderColumns = (columns: IColumn[]): ReactElement => {
    return (
      <Grid2 container>
        {columns.map((column) => (
          <Grid2 key={`form-column-${column.key}`} container>
            {renderRows(column.rows)}
          </Grid2>
        ))}
      </Grid2>
    );
  };

  if (section.rows?.length) {
    return renderRows(section.rows);
  }
  if (section.columns?.length) {
    return renderColumns(section.columns);
  }
  return null;
};
